module.exports = __webpack_public_path__ + "static/img/shuili_1.22936307.png";